// Core lib dependencies.
import Immutable		from 'seamless-immutable';

// Import action types.
import ActionTypes  	from './actionTypes.js';

// Config.
import Config			from './config/config.js';

// Initial state.
var initialState = Immutable({
	shares:[]
});

/**
 * <pre>
 * Sharing module Reducer(s).
 *
 * Summary of responsibilities:
 *
 *  - responds to actions, receives current Redux state and modifies it accordingly.
 *
 * FYI:
 *
 * All {@link https://github.com/reactjs/redux|Redux} state modifications are handled using {@link https://github.com/rtfeldman/seamless-immutable|Seamless-immutable} objects and methods.
 * DO NOT DIRECTLY MODIFY THE REDUX STATE (Immutable should stop you from doing this, but just in case)!
 * </pre>
 *
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 * @see {@link https://github.com/rtfeldman/seamless-immutable|Immutable Documentation}
 *
 * @author Tim Loram
 *
 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 */
const Reducer = {

	/**
	 * Reducer for the sharing actions.
	 *
	 * @param state: 	{object} The current Redux state.
	 * @param action: 	{object} The current Redux action object.
	 */
	rootReducer: (state = initialState, action) => {

		// Execute the appropriate logic based on the received action type.
		switch (action.type) {

			// Share something
			case ActionTypes.SHARE:

				state = state.setIn(['shares'], state.shares.concat({id: action.id, network:action.network, data:action.shareData}));
				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Make sure to return a state even if no action was matched!
			default:
				return state;
		}
	}
}

export default Reducer;